import script from "./AdminSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./AdminSidebar.vue?vue&type=style&index=0&id=46d5189a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46d5189a"]])

export default __exports__